// extracted by mini-css-extract-plugin
export default {"link":"Index_link__udBjF"};